import React, { useState, useEffect, createRef } from "react";

const Form = (props) => {
    const { handleSubmit, handleCancel, setFieldErrors, disabled, children, SaveButtonText } = props;
    const form = createRef();
    const [firstInvalidField, setFirstInvalidField] = useState(null);
    const [formUpdated, setFormUpdated] = useState(false);

    const handleInvalid = (e) => {
        const { id, dataset, validity } = e.target;
        e.preventDefault();

        const message = validity.valueMissing ? `${dataset.label} is Required` : `${dataset.label} is Invalid`;
        setFieldValidation(id, dataset.customvalidationmessage ?? message);
    }

    const handleChange = (e) => {
        setFieldValidation(e.target.id, '');
        setFirstInvalidField(null);
        setFormUpdated(true)
    }

    const setFieldValidation = (fieldId, message) => {
        setFieldErrors(prevState => ({
            ...prevState,
            [fieldId]: message //Add a message for the invalid field
        }));

        if (message && !firstInvalidField) {
            setFirstInvalidField(fieldId);
        }
    }

    useEffect(() => {
        if (firstInvalidField) {
            form.current[firstInvalidField]?.focus();
        }
    }, [firstInvalidField]);

    useEffect(() => {
        form.current['userName']?.focus();
    }, []);

    return (
        <form
            ref={form}
            onSubmit={handleSubmit}
            onInvalid={handleInvalid}
            onChange={handleChange}
        >
            <fieldset disabled={disabled}>
                {disabled && <legend className="visually-hidden">This form is not editable</legend>}
                {children}
                {!disabled && <div className="buttons">
                    <button className="submit" onClick={() => setFirstInvalidField(null)} disabled={!formUpdated}>{SaveButtonText}</button>
                    <button className="cancel" onClick={handleCancel}>Cancel</button>
                </div>}
            </fieldset>
        </form>
    );
}

export default Form;

Form.defaultProps = {
    setFieldErrors: () => { }, //setFieldErrors is not required if form does not need validation
    SaveButtonText: 'Save',
    SaveDisabled: false
}